import { UserService } from '../services/Users';
import _ from 'lodash';
import { CompanyService } from '../services/Companies';
import SessionStorageService from '../services/utilities/SessionStorageService';

// 協力会社の会社情報確認の共通処理

export const propsToCompanyId = props => {
  const companyIds = _.split(props.view.state.id, '.');
  if (Number(companyIds[0]) === 0) {
    return Number(SessionStorageService.getItem('company_id'));
  }
  return Number(companyIds[0]);
};

export const getPartnerCompanyInfo = async companyId => {
  const params = {
    selected_partner_company_id: companyId,
    offset: 0,
    limit: 30,
  };

  // CompanyService.showだけでは不足しているのでgetAgencyRegistableCompaniesで支店情報を補足する
  const [agencyResponse, companyResponse, partnerUsersResponse] = await Promise.all([
    UserService.getAgencyRegistableCompanies(params),
    CompanyService.show(companyId),
    CompanyService.partnerUsers(companyId, { password_reset_notice_flag: true }),
  ]);

  if (agencyResponse.result === false || companyResponse.result === false) {
    return {
      result: false,
    };
  }

  // 会社名は会社情報確認の各タブ共通でgetAgencyRegistableCompaniesから取得
  const companyName = agencyRegistableCompaniesToCompanyName(
    companyId,
    agencyResponse
  );
  const company_branches = agencyResponse.data.entities.company_branches;
  const company_branch = _.find(company_branches, companyBranch => {
    return String(companyBranch.company_id) === String(companyId);
  });
  const company = companyResponse.data.entities.company;
  const icon_image_url = companyResponse.data.entities.icon_image_url;
  const users = partnerUsersResponse.data.entities.users;
  return {
    result: true,
    company,
    companyName,
    icon_image_url,
    users,
    company_branch,
  };
};

// 会社名取得
// 会社情報確認の各タブ共通でgetAgencyRegistableCompaniesから取得
export const getPartnerCompanyName = async companyId => {
  const params = {
    selected_partner_company_id: companyId, // 自社ID
    offset: 0,
    limit: 30,
  };

  const response = await UserService.getAgencyRegistableCompanies(params);
  return agencyRegistableCompaniesToCompanyName(companyId, response);
};

const agencyRegistableCompaniesToCompanyName = (companyId, response) => {
  if (response.result === true) {
    const companies = response.data.entities.agency_registable_companies;
    const company = _.find(companies, company => {
      return String(company.id) === String(companyId);
    });

    return company.name;
  } else {
    return '';
  }
};



// WEBPACK FOOTER //
// ./src/utilities/partnerCompanyConfirmUtil.js